import type { NavigationMode } from '@/config/preferences';
import type { AppMenuItem } from '@/config/types';
import { findMenuKeyPath } from './sidebarNavigation';

export function firstMenuPath(item: AppMenuItem): string | undefined {
  // 分组先进入子页面，避免父级地址命中同路径的业务首页，丢失当前分组。
  return item.children?.map(firstMenuPath).find(Boolean) ?? item.path;
}

export function resolveNavigation(
  items: AppMenuItem[],
  path: string,
  mode: NavigationMode,
  supportsTopNavigation: boolean,
) {
  const rootKey = findMenuKeyPath(items, path)[0];
  const currentRoot = items.find((item) => item.key === rootKey);
  const roots = items.map((item) => ({
    ...item,
    path: firstMenuPath(item),
    children: undefined,
  }));
  const secondary = currentRoot?.children ?? [];
  return {
    roots,
    secondary,
    currentRoot,
    sidebar:
      !supportsTopNavigation || mode === 'side'
        ? items
        : mode === 'mixed'
          ? secondary
          : [],
    top:
      !supportsTopNavigation || mode === 'side' ? [] : mode === 'mixed' ? roots : items,
  };
}
